import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import Gallerydetail from "../components/Gallerydetail";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";

const CategoryPage = () => {
  const {categoryName} = useParams();
  return (
    <>
      <Helmet>
        <title>Culture | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Explore the vibrant gallery of TimeWatch Infocom, showcasing our participation in festivals, official events, and industry exhibitions. Our collection highlights key moments of innovation in biometric solutions, access control systems, and smart security technologies. From corporate events to security technology demonstrations, our gallery captures the essence of our leadership in providing cutting-edge security solutions. Discover how TimeWatch Infocom’s commitment to excellence is celebrated in every event and festival, reflecting our contributions to the advancement of security technologies."
        />
        <link rel="canonical" href={`https://www.timewatchindia.com/${categoryName}`} />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="category">
          <Gallerydetail />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default CategoryPage;
